module.exports = __webpack_public_path__ + "img/icon03.f373cc20.svg";